<!-- =========================================================================================

  説明: 船舶の検索条件を入力するダイアログコンポーネント
  作成者: Kokichi

========================================================================================== -->

<template>
  <div id="nav">
    <vs-prompt
      @accept="search"
      @cancel="cancel"
      @close="close"
      :active.sync="showDialog"
      :title="title"
      :accept-text="acceptText"
      :cancel-text="cancelText"
    >
      <div id="dialog-vessel-search-input-form">
        <span>船舶名</span>
        <vs-input v-model="searchConditionCopy.name" />
        <span class="mt-4 mb-4">登録状態</span>
        <ul class="center mt-4 mb-4">
          <li class="mr-4">
            <vs-radio v-model="searchConditionCopy.isDisabled" vs-value="all"
              >全て</vs-radio
            >
          </li>
          <li class="mr-4">
            <vs-radio v-model="searchConditionCopy.isDisabled" vs-value="enable"
              >有効</vs-radio
            >
          </li>
          <li>
            <vs-radio v-model="searchConditionCopy.isDisabled" vs-value="disabled"
              >無効</vs-radio
            >
          </li>
        </ul>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
export default {
  props: {
    searchCondition: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showDialog: false,
      title: "船舶の検索条件",
      acceptText: "検索",
      cancelText: "キャンセル",
      searchConditionCopy: this.searchCondition
    };
  },
  methods: {
    show() {
      this.showDialog = true;
    },
    search() {
      this.$emit('update:searchCondition', this.searchConditionCopy);
      this.$emit("searchVessels");
      this.showDialog = false;
    },
    close() {
      this.showDialog = false;
    },
    cancel() {
      this.showDialog = false;
    }
  }
};
</script>

<style lang="scss">
#dialog-vessel-search-input-form {
  .vs-input {
    width: 100%;
    margin-top: 10px;
    margin-bottom: 20px;
  }
  ul li {
    display: inline;
  }
}
</style>
